<template>
  <div class="container">
    <h1 class="py-4">トランザクションデータ</h1>
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-md-4">
          <label for="l-pid">取引日</label><br />
          <input
            v-model="transactionDate"
            placeholder="取引日"
            class="input-boot"
          />
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">フォーマット区分</label><br />
          <select v-model="format" class="input-boot">
            <option
              v-for="(display, value) in this.formatCategories"
              :value="value"
              :key="value"
            >
              {{ display }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="l-pid">カード種類</label><br />
          <select v-model="cardType" class="input-boot">
            <option
              v-for="(display, value) in this.card_type_codes"
              :value="value"
              :key="value"
            >
              {{ display }}
            </option>
          </select>
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-primary mr10" @click="clear">クリア</button>
        <button class="btn btn-primary" @click="search">検索</button>
      </div>
      <div class="form-row">
        <div class="form-group col-md-auto">
          <vue-json-to-csv
            :labels="this.csvCurrentFields"
            :json-data="this.csvData"
            :csv-title="this.fileName"
          >
            <button class="btn btn-success" :disabled="loadingCSV">
              CSV ダウンロード
            </button>
          </vue-json-to-csv>
        </div>
      </div>
    </div>
    <div :key="key">
      <div v-if="loading" class="form-row">
        <b-spinner
          class="autoMarginLR"
          variant="primary"
          label="Spinning"
        ></b-spinner>
      </div>
      <div v-if="!loading" class="table-responsive">
        <b-table
          :fields="fields"
          id="dataTable"
          :items="tableData"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <template #head(決済買上)>
            <div class="alignRight">決済買上/入金金額</div>
          </template>
          <template #head(決済ATM手数料)>
            <div class="alignRight">決済ATM手数料</div>
          </template>
          <template #cell(取引日)="data">
            <router-link
              :to="{
                name: 'TransactionDetails',
                query: { transactionId: data.item.transactionId },
              }"
              target="_blank"
              >{{ data.item.取引日 }}</router-link
            >
          </template>
          <template #cell(決済買上)="data">
            <div class="alignRight">{{ data.item.決済買上 }}</div>
          </template>
          <template #cell(決済ATM手数料)="data">
            <div class="alignRight">{{ data.item.決済ATM手数料 }}</div>
          </template>
        </b-table>
        <b-pagination
          class="mt30"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="dataTable"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import master from "@/constants/MasterEnum";
import utils from "@/utils/Utils";
import firebase from "firebase";
import VueJsonToCsv from "vue-json-to-csv";
import prefs from "@/constants/PrefsEnum";
import countries from "@/constants/CountriesEnum";

export default {
  name: "Transactions",
  mixins: [utils, master, prefs, countries],
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  watch: {
    /*     currentPage(value) {
      sessionStorage.currentPage = value;
    }, */
  },
  data() {
    return {
      csvCurrentFields: {},
      currentPage: 1,
      perPage: 10,
      fileName: "",
      labels: [],
      loading: true,
      tableData: [],
      csvData: [],
      db: firebase.firestore(),
      transactionDate: "",
      format: "",
      cardType: "",
      key: 0,
      fields: [
        "取引日",
        "フォーマット区分",
        "摘要区分",
        "決済買上",
        "決済ATM手数料",
        "カード種類",
      ],
    };
  },
  components: {
    VueJsonToCsv,
  },
  created: function() {
    //this.labels = this.tsvFormat.bankitInfo.labels;
    this.loadCollection();
  },
  methods: {
    init() {
      this.tableData = [];
      this.csvData = [];
      this.key = this.key ? 0 : 1;
    },
    clear() {
      this.transactionDate = "";
      this.format = "";
      this.cardType = "";
      this.loadCollection();
    },
    search() {
      let searchParams = {
        transaction_date: this.transactionDate,
        format_category: this.format,
        card_type: this.cardType,
      };
      this.loadCollection(searchParams);
    },
    loadCollection(searchParams = null) {
      this.init();
      this.loading = true;
      this.fileName = this.tsvFormat.transactionData.fileName;
      this.csvCurrentFields = this.tsvFormat.transactionData.labels;

      let query = this.db.collection("transactions");
      if (searchParams !== null) {
        for (const [key, value] of Object.entries(searchParams)) {
          if (value !== "") {
            query = query.where(key, "==", value);
          }
        }
        if (searchParams["transaction_date"] == "") {
          query = query.orderBy("transaction_date", "desc");
        }
        /*  if (searchParams["format_category"] !== "") {
          switch (searchParams["format_category"]) {
            case "01":
              this.fileName = this.tsvFormat.transactionDataNinshou.fileName;
              this.csvCurrentFields = this.tsvFormat.transactionDataNinshou.labels;
              break;
            case "02":
              this.fileName = this.tsvFormat.transactionDataUriage.fileName;
              this.csvCurrentFields = this.tsvFormat.transactionDataUriage.labels;
              break;
            case "03":
              this.fileName = this.tsvFormat.transactionDataNyuushutsukin.fileName;
              this.csvCurrentFields = this.tsvFormat.transactionDataNyuushutsukin.labels;
              break;
            default:
              break;
          }
        } */
      } else {
        query = query.orderBy("transaction_date", "desc");
      }

      query
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.exists) {
              var data = doc.data();
              let tableItem = {
                取引日: data.transaction_date,
                フォーマット区分: data.format_category,
                摘要区分: data.summary_category,
                カード種類: data.card_type,
                transactionId: doc.id,
              };
              let value = "";
              switch (data.format_category) {
                case "01":
                  value = this.setTextWithCode(
                    data.settlement_purchase_amount_code,
                    data.settlement_purchase_amount
                  );
                  tableItem.決済買上 = value;
                  data.settlement_operation_amount = value;
                  break;
                case "02":
                  value = this.setTextWithCode(
                    data.settlement_purchase_amount_code,
                    data.settlement_purchase_amount
                  );
                  tableItem.決済買上 = value;
                  data.settlement_operation_amount = value;
                  break;
                case "03":
                  value = this.setTextWithCode(
                    data.deposit_amount_code,
                    data.deposit_amount
                  );
                  tableItem.決済買上 = value;
                  data.settlement_operation_amount = value;
                  break;
                default:
                  break;
              }
              let val = this.setTextWithCode(
                data.settlement_atm_fee_code,
                data.settlement_atm_fee_amount
              );
              tableItem.決済ATM手数料 = val;
              data.settlement_atm_fee_amount = val;
              let cardTypeText = this.card_type_codes[data.card_type];
              if (cardTypeText !== undefined) {
                tableItem.カード種類 = cardTypeText;
              }
              let formatCategoryText = this.formatCategories[
                data.format_category
              ];
              if (formatCategoryText !== undefined) {
                tableItem.フォーマット区分 = formatCategoryText;
              }
              this.tableData.push(tableItem);
              this.csvData.push(data);
            }
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>
